import { safetylogs } from "../features/safetylogs/Safetylogs";
interface Field {
    title: string;
    name: keyof safetylogs; 
    type: string;
    width: number;
    height?: number; 
    isRequired: boolean;
    options?: string[];
  }
  
export const Safetylogfields: Field[] = [
    {
      title: "Log No",
      name: "logno",
      type: "text",
      width: 450,
      height: 70,
      isRequired: false,
    },
    {
      title: "Project Name",
      name: "projectname",
      type: "dropDown",
      width: 450,
      isRequired: false,
      height: 70,
      options: [], 
    },
    {
      title: "Title",
      name: "title",
      type: "text",
      width: 450,
      height: 70,
      isRequired: false,
    },
    {
      title: "Created By",
      name: "createdby",
      type: "text",
      height: 70,
      width: 350,
      isRequired: false,
    },
    {
      title: "Assigned To",
      name: "assignedto",
      type: "dropDown",
      width: 450,
      height: 70,
      isRequired: false,
      options:[],
    },
    {
      title: "Created Date",
      name: "createddate",
      type: "date",
      height: 70,
      width: 450,
      isRequired: false,
    },
    {
      title: " Description",
      name: "description",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: " Remarks",
      name: "remarks",
      type: "textArea",
      width: 450,
      height: 5,
      isRequired: false,
    },
    {
      title: "Status",
      name: "status",
      type: "dropDown",
      width: 450,
      isRequired: false,
      options: ["Pending", "In progress", "Completed"],
    },  
    {
      title: "Signature",
      name: "signature",
      type: "textArea",
       width: 450,
       height: 75,
       isRequired: false,
    },
    {
      title: "Attachments",
      name: "attachments",
      type: "dropzone",
       width: 450,
       height: 100,
       isRequired: false,
    },
    
];